import type { IAccount } from "@apis/accounts/types"
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@components/ui/select"

type TAccountSelectProps = {
  accounts: IAccount[]
  selectedAccountId: string
  setSelectedAccountId: (account_id: string) => void
}

export const AccountSelect = ({
  accounts,
  selectedAccountId,
  setSelectedAccountId,
}: TAccountSelectProps) => {
  return (
    <div className="tw:flex tw:gap-2 tw:items-center">
      <p>Select Account ID:</p>
      <Select
        value={selectedAccountId || String(accounts[0].account_id)}
        onValueChange={setSelectedAccountId}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select Account Id" />
        </SelectTrigger>
        <SelectContent>
          {accounts.map((account: IAccount, index: number) => {
            const accountId = String(account.account_id)

            return (
              <SelectItem key={`${accountId}-${index}`} value={accountId}>
                {accountId}
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
    </div>
  )
}
